import React from "react"
import { Global, css } from "@emotion/react"

import globalStyles from "styles/globalStyles"
import Layout from "./index"

// Thin wrapper that gatsby-plugin-layout mounts around every page (see gatsby-config).
// Its only job is to decide whether a route gets the full site chrome (the shared
// Layout in ./index.js) or is rendered bare. This keeps ./index.js untouched.
//
// /tenderid-demo is the emergency-profile preview shown ONLY inside the tenderID iframe
// on the homepage. It must NOT get the chrome: the NewsletterButton would appear inside
// the iframe, and ScrollListener + the flex wrappers fight the page's own sticky tab bar
// and internal scroll. Bare = global styles only (fonts/reset also come from the global
// import of global.css in gatsby-browser), then the page itself.
const BARE_ROUTES = ["/tenderid-demo"]

const RootLayout = ({ children, ...props }) => {
  const pathname = props.location?.pathname || ""
  const isBare = BARE_ROUTES.some((r) => pathname.startsWith(r))

  if (isBare) {
    return (
      <>
        <Global
          styles={css`
            @layer marketing-components {
              ${globalStyles}
            }
            /* This route lives in a fixed-size iframe. Global mobile styles use vh/dvh,
               -webkit-fill-available, and safe-area padding to track the browser chrome
               — inside an iframe those resolve against the top-level viewport, not the
               iframe, and leave a white strip when the bottom bar hides/shows. Pin the
               whole chain to the iframe's pixel height instead. */
            html,
            body,
            #___gatsby,
            #gatsby-focus-wrapper,
            [data-tenderid-demo-page] {
              height: 100% !important;
              min-height: 0 !important;
              max-height: 100% !important;
              overflow: hidden !important;
            }
            [data-tenderid-demo-page] {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              width: 100% !important;
              /* Standalone (opened directly by QR): 100dvh tracks the mobile browser
                 bar so no white strip appears when it hides. Inside the iframe,
                 syncTenderidDemoFrame overrides this with the exact pixel height, so
                 the dvh value (which would resolve against the top-level viewport in an
                 iframe) never actually applies there. */
              height: 100vh !important;
              height: 100dvh !important;
              max-height: 100dvh !important;
              overflow-x: hidden !important;
              overflow-y: auto !important;
              overscroll-behavior-y: contain !important;
            }
            body {
              display: block !important;
              margin: 0 !important;
              padding: 0 !important;
            }
            html {
              scrollbar-width: none;
            }
            *::-webkit-scrollbar {
              display: none;
            }
          `}
        />
        {children}
      </>
    )
  }

  return <Layout {...props}>{children}</Layout>
}

export default RootLayout
